import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=2fe35aac&scoped=true&"
import script from "./user-profile.vue?vue&type=script&lang=js&"
export * from "./user-profile.vue?vue&type=script&lang=js&"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=2fe35aac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe35aac",
  null
  
)

export default component.exports